// src/components/admin/UserModal.jsx
// Modal de detalle de usuario. Las acciones (otorgar acceso / suspender / hacer
// admin / eliminar) por ahora son placeholders sin escritura — al hacer click,
// se confirma con el operador y se loggea la intención. Wiring real con
// Cloud Functions queda pendiente para evitar tocar Firestore desde el
// cliente con bypass de rules.

function tsMs(v) {
  if (!v) return null;
  if (typeof v === 'object' && typeof v.seconds === 'number') return v.seconds * 1000;
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    const t = new Date(v).getTime();
    return Number.isFinite(t) ? t : null;
  }
  return null;
}
function fmtDateTime(ms) {
  if (!ms) return '—';
  const d = new Date(ms);
  if (!Number.isFinite(d.getTime())) return '—';
  return d.toLocaleString('es-CL', { dateStyle: 'medium', timeStyle: 'short' });
}

const PLAN_LABEL = { monthly: 'Mensual', quarterly: 'Trimestral', biannual: 'Semestral' };

export default function UserModal({ user, onClose }) {
  const created = tsMs(user.fechaCreacion) || tsMs(user.createdAt);
  const expires = tsMs(user.accessUntil);
  const plan = user.role === 'admin' ? 'Admin' : (PLAN_LABEL[user.lastPaymentPlan] || '—');
  const provider = user.metodoRegistro || (user.email ? 'email' : '—');
  const tg = user.telegramChatId ? 'Vinculado' : '—';

  function notImplemented(action) {
    const ok = window.confirm(
      `Acción "${action}" todavía no está conectada al backend.\n\n` +
      'Para evitar bypass de Firestore Rules, las acciones críticas deben ' +
      'ejecutarse vía Cloud Function. Esto se cablea en una iteración posterior.\n\n' +
      '¿Quieres registrar la intención en consola del navegador?'
    );
    if (ok) {
      // eslint-disable-next-line no-console
      // Tracking placeholder hasta wiring con Cloud Functions (intencional).
      // eslint-disable-next-line no-console
      console.warn('[admin][intent]', action, { uid: user.uid, email: user.email });
    }
  }

  function confirmAdmin() {
    const ok = window.confirm('¿Convertir este usuario en admin? Acción crítica.');
    if (!ok) return;
    const ok2 = window.confirm('Confirmá una segunda vez: dará acceso TOTAL al panel /gestion.');
    if (!ok2) return;
    notImplemented('convertir en admin');
  }
  function confirmDelete() {
    const ok = window.confirm('¿Eliminar usuario y su doc en Firestore? Acción IRREVERSIBLE.');
    if (!ok) return;
    const ok2 = window.confirm('Confirmá una segunda vez para proceder.');
    if (!ok2) return;
    notImplemented('eliminar usuario');
  }

  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3 className="admin-modal-title">Detalle de usuario</h3>
          <button className="admin-modal-close" onClick={onClose} aria-label="Cerrar">×</button>
        </div>

        <div className="admin-modal-row">
          <span className="label">Email</span>
          <span className="value mono">{user.email || '—'}</span>
        </div>
        <div className="admin-modal-row">
          <span className="label">Nombre</span>
          <span className="value">{user.nombre || user.displayName || '—'}</span>
        </div>
        <div className="admin-modal-row">
          <span className="label">UID</span>
          <span className="value mono" style={{ fontSize: 11 }}>{user.uid}</span>
        </div>
        <div className="admin-modal-row">
          <span className="label">Plan</span>
          <span className="value">{plan}</span>
        </div>
        <div className="admin-modal-row">
          <span className="label">Estado</span>
          <span className="value">
            <span className="admin-pill" data-tone={user._status}>{user._status}</span>
          </span>
        </div>
        <div className="admin-modal-row">
          <span className="label">Registro</span>
          <span className="value">{fmtDateTime(created)}</span>
        </div>
        <div className="admin-modal-row">
          <span className="label">Vence</span>
          <span className="value">{fmtDateTime(expires)}</span>
        </div>
        <div className="admin-modal-row">
          <span className="label">Provider</span>
          <span className="value">{provider}</span>
        </div>
        <div className="admin-modal-row">
          <span className="label">Telegram</span>
          <span className="value">{tg}</span>
        </div>

        <div className="admin-modal-actions">
          <button className="admin-modal-btn" onClick={() => notImplemented('otorgar 30 días')}>
            Otorgar 30 días gratis
          </button>
          <button className="admin-modal-btn" onClick={() => notImplemented('otorgar 90 días')}>
            Otorgar 90 días gratis
          </button>
          <button className="admin-modal-btn" onClick={() => notImplemented('suspender')}>
            Suspender cuenta
          </button>
          <button className="admin-modal-btn" onClick={confirmAdmin}>
            Convertir en admin
          </button>
          <button className="admin-modal-btn" data-danger="true" onClick={confirmDelete}>
            Eliminar usuario
          </button>
        </div>
      </div>
    </div>
  );
}
